import EventEmitter from 'events';
import { TypedEmitter } from '../util';
import { PartialWindow } from './partialWindow';

interface NavigationEventState {
  prevented: boolean;
  pause: () => { resume: () => unknown };
}

export class NavigationManager {
  window: PartialWindow;

  constructor(window: PartialWindow) {
    this.window = window;
  }

  readonly events = new EventEmitter() as TypedEmitter<{
    navigation: (state: NavigationEventState) => unknown;
    navigationPromptResult: (leave: boolean) => unknown;
  }>;

  navigate(url: string) {
    const state = {
      prevented: false,
      pause: () => {
        return {
          resume: () => {
            this.window.location.href = url;
          },
        };
      },
    };
    for (const navigation of this.events.listeners('navigation')) {
      navigation(state);
    }

    if (!state.prevented) {
      this.window.location.href = url;
    }
  }

  navigateToPage({ pageId }: { pageId: string }) {
    const url = new URL(this.window.location.href);
    url.pathname = `/page/${pageId}`;
    this.navigate(url.href);
  }

  confirmLeavePage() {
    this.events.emit('navigationPromptResult', true);
  }

  subscribe(onNavigation: (state: NavigationEventState) => unknown) {
    this.events.on('navigation', onNavigation);

    return () => {
      this.events.off('navigation', onNavigation);
    };
  }
}
